import { render, staticRenderFns } from "./OrderCreator.vue?vue&type=template&id=b3135474&scoped=true&"
import script from "./OrderCreator.vue?vue&type=script&lang=js&"
export * from "./OrderCreator.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreator.vue?vue&type=style&index=0&id=b3135474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3135474",
  null
  
)

export default component.exports